import React from 'react';
import { motion } from 'framer-motion';

const publicUrl = process.env.PUBLIC_URL || '';

export default function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid rgba(255, 255, 255, 0.2)',
      padding: '3rem 2rem 2rem',
      background: 'var(--navy)',
      color: 'white',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '3rem', marginBottom: '3rem' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '1rem' }}>
              <img src={`${publicUrl}/logo192.png`} alt="Findura Infosys" style={{ width: 32, height: 32, borderRadius: 8 }} />
              <span style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: '1.1rem', color: 'white' }}>Findura <span style={{ color: 'var(--orange)' }}>Infosys</span></span>
            </div>
            <p style={{ fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.7, maxWidth: 280, marginBottom: '1rem' }}>
              Technology for You — delivering enterprise IT solutions to businesses across Zambia and Africa.
            </p>
            <div style={{ fontSize: '0.8rem', color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.7, maxWidth: 280, gap: '0.5rem' }}>
              <span>📍 Stand Number 100/647 Off Joel Kapililisha     Street, Ibex Hill, Lusaka, Zambia</span><br/>
              <span>📞 <a href="tel:+260772420450" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = 'var(--orange)'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'inherit'; }}
              >+260 772 420 450</a></span><br/>
              <span>✉️ <a href="mailto:info@findurainfosys.com" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = 'var(--orange)'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'inherit'; }}
              >info@findurainfosys.com</a></span>
            </div>
          </div>

          {[
            { title: 'Services', links: [
              { name: 'Software Development', href: '#services' },
              { name: 'Web & Email Services', href: '#services' },
              { name: 'Microsoft Cloud', href: '#services' },
              { name: 'IT Consulting', href: '#services' },
              { name: 'Business Systems', href: '#services' },
            ]},
            { title: 'Company', links: [
              { name: 'About Us', href: '#/about' },
              { name: 'Clients', href: '#clients' },
              { name: 'Partners', href: '#partners' },
              { name: 'Insights', href: '#' },
              { name: 'Legal & Compliance', href: '#' },
            ]},
            { title: 'Legal', links: [
              { name: 'NAPSA Registered', href: '#' },
              { name: 'CEEC Certified', href: '#' },
              { name: 'ZPPA Registered', href: '#' },
              { name: 'Workers Comp. Board', href: '#' },
              { name: 'Privacy Policy', href: '#' },
            ]},
          ].map(({ title, links }) => (
            <div key={title}>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: '0.9rem', marginBottom: '1rem', color: 'white' }}>{title}</div>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {links.map(l => (
                  <li key={l.name}>
                    <a href={l.href} style={{ fontSize: '0.825rem', color: 'rgba(255, 255, 255, 0.7)', transition: 'color 0.2s' }}
                      onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = 'var(--orange)'; }}
                      onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'rgba(255, 255, 255, 0.7)'; }}
                    >{l.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div style={{ borderTop: '1px solid rgba(255, 255, 255, 0.2)', paddingTop: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <span style={{ fontSize: '0.8rem', color: 'rgba(255, 255, 255, 0.7)' }}>© 2026 Findura Infosys Limited. All rights reserved.</span>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            {['NAPSA', 'CEEC', 'ZPPA', 'Microsoft Partner'].map(badge => (
              <span key={badge} style={{
                padding: '0.2rem 0.6rem', borderRadius: 100, fontSize: '0.65rem', fontWeight: 600,
                background: 'rgba(255, 255, 255, 0.1)', color: 'rgba(255, 255, 255, 0.7)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }}>{badge}</span>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          footer > div > div:first-child { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 600px) {
          footer > div > div:first-child { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
